module.exports = __webpack_public_path__ + "static/media/icon_project_chat.5ce9a5cf.svg";